
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenMemberRole } from './GenMemberRole';
import { GenMemberStatus } from './GenMemberStatus';

export class GenCommunityMember {

    communityId: number;
    email: string;
    firstName: string;
    justification: string;
    lastName: string;
    role: GenMemberRole;
    status: GenMemberStatus;
    userId: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genCommunityMember: GenCommunityMember);

    constructor( input?: GenCommunityMember ) {
        if ( input && typeof input !== 'number' ) {
            this.communityId = input.communityId; // int [number]
            this.email = input.email; // string [string]
            this.firstName = input.firstName; // string [string]
            this.justification = input.justification; // string [string]
            this.lastName = input.lastName; // string [string]
            this.role = (typeof input.role === 'string') ? GenMemberRole.forName(<string> input.role) : <any> input.role; // GenMemberRole
            this.status = (typeof input.status === 'string') ? GenMemberStatus.forName(<string> input.status) : <any> input.status; // GenMemberStatus
            this.userId = input.userId; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenCommunityMember[] {
        if (arr && arr.map) {
          return arr.map(a => new GenCommunityMember(a));
        } else {
          return [];
        }
    }
}

